export const i18nContentHash = '8fe9b00'
